// Default form state
const defaultWebPaymentFormState = {
  email: "",
  stateId: "",
  countryAlpha2: "",
  locality: "",
  apartment: "",
  address: "",
  name: "",
  countryId: "",
  postal: "",
  deliveryMethod: "",
  voucher: "",
  plan_id: "",
  headset_purchase_token: "",
  headsetType: "regular",
  phoneNumber: "",
  promoCode: "",
  promoApplied: "",
  referrer: "",
};

const webPaymentFields = [
  "email",
  "stateId",
  "countryAlpha2",
  "locality",
  "apartment",
  "address",
  "name",
  "countryId",
  "headsetType",
  "postal",
  "deliveryMethod",
  "voucher",
  "plan_id",
  "headset_purchase_token",
  "phoneNumber",
  "itemType",
  "promoCode",
  "promoApplied",
  "referrer",
];

export { defaultWebPaymentFormState, webPaymentFields };
